export const DEFAULT_INTERVIEW_READINESS_FORM_DATA = {
  inPlacementGroup: false,
  inMockGroup: false,
  inUnderpreparedGroup: false,
  allModulesComplete: false,
  projectSubmitted: false,
  studentReadiness: null,
  trainerReadiness: null,
  resumeReadySubmitted: false,
  resumeSubmissionDeadline: '',
  resumeReviewed: null,
  resumeChangesNeeded: null,
  mockInterviewDone: false,
  numberOfMockInterviews: 0,
  communicationSkillsRating: null,
  attitudeRating: null,
  presentationRating: null,
  technicalReadinessRating: null,
  areasToImprove: '',
  feedbackScore: '',
  interviewReady: null
};

/** Convert boolean|null to select-friendly string values */
export const boolToSelectValue = (value) => {
  if (value === true) return 'true';
  if (value === false) return 'false';
  return '';
};

export const selectValueToBool = (value) => {
  if (value === '' || value === null || value === undefined) return null;
  return value === 'true';
};

export const mapReadinessToFormData = (data) => {
  if (!data) return { ...DEFAULT_INTERVIEW_READINESS_FORM_DATA };

  return {
    inPlacementGroup: Boolean(data.inPlacementGroup),
    inMockGroup: Boolean(data.inMockGroup),
    inUnderpreparedGroup: Boolean(data.inUnderpreparedGroup),
    allModulesComplete: Boolean(data.allModulesComplete),
    projectSubmitted: Boolean(data.projectSubmitted),
    studentReadiness: data.studentReadiness ?? null,
    trainerReadiness: data.trainerReadiness ?? null,
    resumeReadySubmitted: Boolean(data.resumeReadySubmitted),
    resumeSubmissionDeadline: data.resumeSubmissionDeadline ? data.resumeSubmissionDeadline.split('T')[0] : '',
    resumeReviewed: data.resumeReviewed ?? null,
    resumeChangesNeeded: data.resumeChangesNeeded ?? null,
    mockInterviewDone: Boolean(data.mockInterviewDone),
    numberOfMockInterviews: data.numberOfMockInterviews ?? 0,
    communicationSkillsRating: data.communicationSkillsRating ?? null,
    attitudeRating: data.attitudeRating ?? null,
    presentationRating: data.presentationRating ?? null,
    technicalReadinessRating: data.technicalReadinessRating ?? null,
    areasToImprove: data.areasToImprove || '',
    feedbackScore: data.feedbackScore || '',
    interviewReady: data.interviewReady ?? null
  };
};

/** Normalize form state before POST — avoids sending invalid numbers to the API */
export const prepareInterviewReadinessPayload = (formData) => ({
  ...formData,
  numberOfMockInterviews: parseInt(String(formData.numberOfMockInterviews ?? 0), 10) || 0,
  communicationSkillsRating: formData.communicationSkillsRating || null,
  attitudeRating: formData.attitudeRating || null,
  presentationRating: formData.presentationRating || null,
  technicalReadinessRating: formData.technicalReadinessRating || null,
  resumeSubmissionDeadline: formData.resumeSubmissionDeadline || null,
  areasToImprove: formData.areasToImprove || null,
  feedbackScore: formData.feedbackScore || null,
});
